<template>
  <input
    :type="type"
    :id="name"
    :name="name"
    :placeholder="placeholder"
    :required="false"
    :disabled="disabled"
    :min="min"
    :max="max"
    :step="step"
    :value="data"
    class="tm-form-input"
    @input="handleInput"
    @blur="handleBlur"
    @focus="handleFocus"
  />
</template>

<script>
export default {
  name: "tm-input",
  props: {
    name: {
      type: String,
    },
    type: {
      type: String,
      default: "text",
      validator: (value) =>
        ["text", "email", "password", "number"].includes(value),
    },
    placeholder: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    value: {
      type: [String, Number],
      default: "",
    },
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    min: {
      type: [String, Number],
      default: null,
    },
    max: {
      type: [String, Number],
      default: null,
    },
    step: {
      type: [String, Number],
      default: null,
    },
    validation: {
      type: Array,
      default: () => [],
    },
    pattern: {
      type: String,
      default: "",
    },
    patternMessage: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      error: "",
      data: this.value,
    };
  },
  methods: {
    handleInput(event) {
      const value = event.target.value;
      this.data = value;
      this.$emit("input", this.name, value);
      // this.$emit("change", this.name, value);
      this.validation.forEach((rule) => {
        if (rule.trigger === "input") {
          this.$emit("trigger", this.name, value);
        }
      });
    },

    handleBlur(event) {
      const value = event.target.value;
      this.validation.forEach((rule) => {
        if (rule.trigger === "blur") {
          this.$emit("trigger", this.name, value);
        }
      });
    },

    handleFocus() {
      this.$emit("focus");
    },
  },
};
</script>

<style scoped>
.tm-form-input {
  width: 100%;
  padding: 0 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  transition: border-color 0.3s ease;
  box-sizing: border-box;
}

.tm-form-input input {
  outline: none;
  border: none;
  background-color: transparent;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 0;
}

input:-webkit-autofill {
  transition: background-color 5000s ease-in-out 0s;
}

.tm-form-input:focus {
  outline: none;
  border-color: #3498db;
  box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.2);
}

.tm-form-input:disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
}
</style>
